<template>
    <div>
        <b-card title="" :border-variant="!disabled ? 'primary':'secondary'">
            <div class="d-flex align-items-center justify-content-between mb-1">
                <h5 class="mb-0">Contrato EE Cliente</h5>
                <b-button v-if="!disabled && can('create_vhe_master_contract_client_ee')"
                           variant="outline-success"
                          :disabled="hasMatchingDocument"
                    @click="addRow"
                >
                    <feather-icon
                        icon="PlusIcon"
                        size="16"
                        variant="success"
                        class="cursor-pointer "
                    />
                </b-button>
            </div>

            <form-base-document
                :documents-state-data="documents_client_contract_e_e"
                :documents-columns="columns"
                :documents-route="documents_by_route_client_contract_e_e"
                :context="'client-contract-ee'"
                :create-permission="can('create_vhe_master_contract_client_ee')"
                :delete-permission="can('delete_vhe_master_contract_client_ee')"
            />
        </b-card>

    </div>
</template>

<script>
import {BCard, BButton} from 'bootstrap-vue'
import {mapState} from "vuex"
import {createHelpers} from "vuex-map-fields"
import formBaseDocument
    from "@/views/vhe/masters_installations/form/tabDocuments/components/base/formBaseDocument"

const {mapFields} = createHelpers({
    getterType: 'masterInstallationDocumentsVhe/getField',
    mutationType: 'masterInstallationDocumentsVhe/updateField',
})

export default {
    name: "FormGeneralDocuments",
    components: {
        BButton,
        BCard,
        formBaseDocument

    },
    props: {
        disabled: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            columns: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'signature_date', label: 'Fecha Firma', sortable: false},
                {key: 'contract_start_date', label: 'Fecha Inicio Contrato', sortable: false},
                {key: 'contract_end_date', label: 'Fecha Fin Contrato', sortable: false},
                {key: 'scope', label: 'Alcance', sortable: false},
                {key: 'observations', label: 'Observaciones', sortable: false},
            ],
        }
    },
    computed: {
        ...mapState('masterInstallationVhe', ['master_installation']),
        ...mapState('masterInstallationDocumentsVhe', []),
        ...mapFields({
            documents_client_contract_e_e: 'documents_client_contract_e_e',
            documents_by_route_client_contract_e_e: 'documents_by_route_client_contract_e_e',
        }),
        hasMatchingDocument() {
          return this.documents_client_contract_e_e.some(doc => doc.empty_row === true)
        }
    },
    mounted() {
       this.context = 'client-contract-ee'
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        addRow() {
            const newRow = {
                empty_row: true,
                accredits: 0,
                signature_date: null,
                contract_start_date: null,
                contract_end_date: null,
                signature_endesa: null,
                signature_client: null,
                scope: null,
                route: this.master_installation.installation_code + '/CONTRATO_CLIENTE',
                observations: null,
                options: null,
                master_installation_id: this.master_installation.id,
            }

            this.documents_client_contract_e_e.push(newRow)
            this.documents_client_contract_e_e.editedRow = newRow
        },
    }
}
</script>